import { UpAlbum } from '../uplus-api/modules/upalbum';
import { NebulaAlbumPlugin } from '../nebula-class/plugins/nebula-album-plugin';
import './upAppinfoModule';
export default new UpAlbum(new NebulaAlbumPlugin());